import { render } from "./BlogImplantsRejectionPosibility.vue?vue&type=template&id=dcd0e236"
import script from "./BlogImplantsRejectionPosibility.vue?vue&type=script&lang=js"
export * from "./BlogImplantsRejectionPosibility.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__